import React from 'react';
import { Accordion, Body, Box } from '@iris/react-components';

export type BlpAccordionPanelProps = {
  value: string;
  title: string;
  titleClassName?: string;
  itemClassName?: string;
  contentWrapperClassName?: string;
  triggerTestId?: string;
  children: React.ReactNode;
};

// Shared accordion panel for the BLP page. Wraps Iris Accordion Item/Trigger/Content
// so all sections render the same structure.
export default function BlpAccordionPanel({
  value,
  title,
  titleClassName,
  itemClassName,
  contentWrapperClassName,
  triggerTestId,
  children,
}: BlpAccordionPanelProps) {
  const body =
    typeof children === 'string' ? (
      <Body size="md" as="p" className="!mb-0">
        {children}
      </Body>
    ) : (
      children
    );

  return (
    <Accordion.Item value={value} className={itemClassName}>
      <Accordion.Trigger data-testid={triggerTestId}>
        {titleClassName ? <span className={titleClassName}>{title}</span> : title}
      </Accordion.Trigger>
      <Accordion.Content>
        {contentWrapperClassName ? (
          <Box className={contentWrapperClassName}>{body}</Box>
        ) : (
          body
        )}
      </Accordion.Content>
    </Accordion.Item>
  );
}
